import { MissionEventHandler } from "../mission"

export default class DroneTrail extends MissionEventHandler {
  constructor(mission, layerParent) {
    super(mission)

    this.layer = L.layerGroup()
    this.layer.addTo(mymap)
    this.overlay = addOverlay("Drone Trail", this.layer, layerParent)
  }

  /**
   * Keeps a running state of the drone trail and returns the next LatLng coordinate when valid
   * 
   * @param {MissionMessage} message The step data for the current mission
   * @returns LatLng or undefined
   */
  processMessage(message) {
    if (message.type === 'MISSION_ROAM') {
      this.curLead = message.currentId
    } else if (message.type === 'SKYLINK_ADV_STATUS') {
      // TODO:  Fix the check for valid remote radio
      if (message.data.localSource.deviceId == this.curLead && message.data.remote.position.latitude != 0) {
        return [message.data.remote.position.latitude, message.data.remote.position.longitude]
      }
    }
    return
  }

  setDroneLine(segments) {
    this.droneline = L.polyline(segments, { color: '#3BADD2', opacity: 0.7 }).addTo(this.layer)
  }

  handleMissionIndexJump(targetIndex) {
    if (this.droneline) this.droneline.removeFrom(this.layer)

    const segments = []
    this.curLead = undefined

    for (let i = 0; i < targetIndex; i++) {
      const message = this.mission.history[i]

      const latlng = this.processMessage(message)
      if (latlng) segments.push(latlng)
    }
    this.setDroneLine(segments)
  }

  handleMissionStep(entry) {
    const latlng = this.processMessage(entry)
    if (latlng) {
      if (this.droneline) {
        this.droneline.addLatLng(latlng)
      } else {
        this.setDroneLine([latlng])
      }
    }
  }

  handleMissionHistoryLoad() {
    this.handleMissionIndexJump(this.mission.replayInfo.currentIndex)
  }

  cleanup() {
    super.cleanup()
    if (this.droneline) this.droneline.removeFrom(this.layer)
    this.layer.removeFrom(mymap)
    removeOverlay(this.overlay)
  }
}